"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Stats {
    constructor(arr) {
        this.arr = arr;
    }
    avg() {
        return Stats.sum(this.arr) / this.arr.length;
    }
    // sample standard deviation
    std() {
        const mu = this.avg();
        const diffArr = this.arr.map(a => (a - mu) ** 2);
        return Math.sqrt(Stats.sum(diffArr) / (diffArr.length - 1));
    }
    quantile(q) {
        const sorted = this.sorted();
        const pos = (sorted.length - 1) * q;
        const base = Math.floor(pos);
        const rest = pos - base;
        if (sorted[base + 1] !== undefined) {
            return sorted[base] + rest * (sorted[base + 1] - sorted[base]);
        }
        else {
            return sorted[base];
        }
    }
    min() {
        const arr = this.sorted();
        return arr[0];
    }
    max() {
        const arr = this.sorted();
        return arr[arr.length - 1];
    }
    static sum(arr) {
        return arr.reduce((a, b) => a + b, 0);
    }
    sorted() {
        const arr = this.arr.map(x => x);
        return arr.sort((a, b) => a - b);
    }
}
exports.default = Stats;
